import { combineReducers } from "redux";
import * as actions from "./actions";
import { ActionType, getType } from "typesafe-actions";

export type Action = ActionType<typeof actions>;

export type State = Readonly<{
  loginType: string;
  isLoading: boolean;
}>;

export default combineReducers<State, Action>({
  isLoading: (state = false, action: Action) => {
    switch (action.type) {
      case getType(actions.getLoginTypeUrl.request):
        return true;
      case getType(actions.getLoginTypeUrl.success):
      case getType(actions.getLoginTypeUrl.failure):
        return false;
      default:
        return state;
    }
  },
  loginType: (state: any = { loginType: "" }, action: Action) => {
    switch (action.type) {
      case getType(actions.getLoginTypeUrl.request):
      case getType(actions.getLoginTypeUrl.failure):
        return state;
      case getType(actions.getLoginTypeUrl.success):
        return action.payload;
      default:
        return state;
    }
  },
});
